.location-page.bar-page
  include ../location-base/location-page-header.pug
  +location-page-header("Bars")
